import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdbIconComponent } from './icon.component';

@NgModule({
  declarations: [MdbIconComponent],
  imports: [CommonModule],
  exports: [MdbIconComponent],
})
export class MdbIconModule {}
